import ApiClient from './ApiClient';

export default class UserApi {
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getUsers(opts) {
    return this.apiClient.get({ path: '/api/identity/users', params: (opts || {}) });
  }

  getManagedUsers(opts) { // { enabled: boolean }
    return this.apiClient.get({ path: '/api/identity/users/managed', params: (opts || {}) });
  }

  createUser(body) {
    return this.apiClient.post({ path: '/api/identity/users', body });
  }

  getUser(userId) {
    // verify the required parameter 'userId' is set.
    if (userId === undefined || userId === null) {
      throw new Error("Missing the required parameter 'userId' when calling getUser");
    }
    return this.apiClient.get({ path: `/api/identity/users/${userId}` });
  }

  deleteUser(userId) {
    // verify the required parameter 'userId' is set.
    if (userId === undefined || userId === null) {
      throw new Error("Missing the required parameter 'userId' when calling deleteUser");
    }
    return this.apiClient.del({ path: `/api/identity/users/${userId}` });
  }

  updateUser(userId, body) {
    // verify the required parameter 'userId' is set.
    if (userId === undefined || userId === null) {
      throw new Error("Missing the required parameter 'userId' when calling updateUser");
    }
    return this.apiClient.put({ path: `/api/identity/users/${userId}`, body });
  }
}
